import { styled } from '@mui/material/styles';
import { COLOR } from '@src/styles/color';

export const StyledFilter = styled('div')`
  display: flex;
  gap: 8px;
  align-items: center;
  padding: 16px;
  margin-bottom: ${(props) => (props.hasTags ? '8px' : '')};
  .filter-container {
    margin-top: 12px;
  }

  .filter-search-input {
    width: calc(80% - 8px);
  }

  .filter-btn {
    position: relative;
    padding: 7px;
    gap: 12px;
    color: ${COLOR.colorFilterInput};
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 8px;
    border: 1px solid ${COLOR.borderFilterInput};
    img {
      width: 24px;
    }
    .circle-btn {
      position: absolute;
      top: -20%;
      left: 82%;
    }
  }
`;
